export const environment = {
  production: false,
  serverUrl: 'https://api2.steelheaven.zeroto1.co.in/api/v1',
  beamCuttingURL: 'https://rod.steelheaven.zeroto1.co.in/uploadexcel/'
};